import { Breadcrumbs as BreadcrumbsComponent } from '@bridebook/web/app-basic/components/breadcrumbs/breadcrumbs.component';
import { BreadcrumbsProps } from '@bridebook/web/app-basic/components/breadcrumbs/breadcrumbs.types';
import { getArticle } from '@bridebook/web/app-basic/lib/article/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, memo } from 'react';
import { getBreadcrumbsArticles } from '@bridebook/web/app-shared/lib/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

const BreadcrumbsContainer: FC<BreadcrumbsProps> = ({ center = true, reloadOnLast }) => {
  const article = useSelector(getArticle);
  const { title } = article || {};
  const breadcrumbsData = getBreadcrumbsArticles(title || '', UrlHelper.advice);

  return (
    <BreadcrumbsComponent
      reloadOnLast={reloadOnLast}
      breadcrumbsData={breadcrumbsData}
      center={center}
    />
  );
};

export const Breadcrumbs = memo(BreadcrumbsContainer);
